import { render, staticRenderFns } from "./AddMetricButton.vue?vue&type=template&id=7dad2b7c&scoped=true"
import script from "./AddMetricButton.vue?vue&type=script&lang=js"
export * from "./AddMetricButton.vue?vue&type=script&lang=js"
import style0 from "./AddMetricButton.vue?vue&type=style&index=0&id=7dad2b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad2b7c",
  null
  
)

export default component.exports